import React from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "@components/CustomTable";
import ChildTable from "./ChildTable";
import { ZERO_VALUE } from "@utils/constants";

const MainTable = ({
  columns,
  childrenColumns,
  matchingRecords,
  childrenRecords,
  selectedRows,
  setSelectedRows,
  attributesPopupOpen,
  setAttributesPopupOpen,
  setCurrentTooltip,
  noData,
}) => {
  const { t: translate, i18n } = useTranslation();

  const renderChildTable = (children) => {
    return (
      <ChildTable
        data={children}
        childrenColumns={childrenColumns}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        attributesPopupOpen={attributesPopupOpen}
        setAttributesPopupOpen={setAttributesPopupOpen}
        setCurrentTooltip={setCurrentTooltip}
      />
    );
  };

  const pinningInitialState = ["pin"];

  return (
    <div className="p-5 w-full flex flex-col gap-5">
      <CustomTable
        language={i18n.language}
        externalData={matchingRecords}
        columnsWithoutPin={columns}
        loading={false}
        title={translate("exception-details.title")}
        pinningInitialState={pinningInitialState}
        setParentSelectedValues={() => {}}
        prefix="AttemptMatching_ExceptionDetails"
        pinnedRowHeight={62}
        maxTableHeight={400}
        showFilter={false}
        minimalTable={true}
        hideActionColumn={true}
        noData={noData}
        isExpandable={true}
        allowRowPinning={false}
        showAccessibility={true}
        pinCondition={(row) => {
          return true;
        }}
        expandedViewRow={(row) => {
          const children = childrenRecords.filter(
            (record) =>
              record.parentRecordID === row.original.MatchingRecordId
          );
          return renderChildTable(children);
        }}
        selectableCondition={(row, isHeader) => {
          return false;
        }}
        setExternalSelectedState={(selectedRows) => {
          setSelectedRows(selectedRows);
        }}
        autoFillData={false}
        rowCustomID={(row) => {
          return row.PromotedRecordId;
        }}
        customSubRows={(row) => {
          return row.DestinationRecords;
        }}
        initialTableVisibility={matchingRecords?.length > ZERO_VALUE}
        isRowExpandedByDefault={true}
      />
    </div>
  );
};

export default MainTable;
